// src/pages/Impressum.tsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { usePublicLang } from "../config/i18n/public";

export default function Impressum() {
  const { copy } = usePublicLang();
  const c = copy.legal.impressum;
  return (
    <div className="min-h-screen flex flex-col">  {/* make full-height flex column */}
      <Header />

      <main className="flex-1">                   {/* let content take the leftover space */}
        <div className="max-w-3xl mx-auto p-6 text-gray-800">
          <h1 className="text-3xl font-bold mb-6">{c.title}</h1>

          {c.sections.map((section, idx) => (
            <section key={idx} className="mb-6">
              <h2 className="text-xl font-semibold mb-2">{section.title}</h2>
              {section.lines?.map((line, i) => {
                const isEmailLine = section.email && i === section.lines.length - 1;
                if (isEmailLine) {
                  return (
                    <p key={i}>
                      {line}{" "}
                      <a
                        href={`mailto:${section.email}`}
                        className="text-blue-600 hover:underline"
                      >
                        {section.email}
                      </a>
                    </p>
                  );
                }
                return <p key={i}>{line}</p>;
              })}
              {section.body && <p>{section.body}</p>}
            </section>
          ))}
        </div>
      </main>

      <Footer />                                  {/* stays at bottom, no big gap */}
    </div>
  );
}
